import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EndUserState } from 'types';

export const initialState: EndUserState = {
  loading: false,
  endUserList: [],
  reset: false
};

const slice = createSlice({
  name: 'EndUser',
  initialState,
  reducers: {
    setEndUserList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.endUserList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setEndUserList, reset } = slice.actions;

export default slice.reducer;
